import * as React from "react";

interface Props {}

export const ModalFooter: React.FC<Props> = ({ children }) => {
  return <div className="modal-footer">{children}</div>;
};
